const LeftArrowSvg = () => (
  <svg
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.44281 0.942809L1.39543 6.99019L0.452621 6.04738L6.5 0L7.44281 0.942809Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 12.0948L1.39543 6.99019L2.33824 6.04738L7.44281 11.1519L6.5 12.0948Z"
      fill="white"
    />
  </svg>
);

export default LeftArrowSvg;
